<section class="healthcare-banner instool aashi">
    <div class="container">
        <div class="row zmc">
            <div class="col-lg-9 col-md-9 col-sm-12 col-12 service-heading">
                <div class="headtext">
                    <h1>A Customer-Centric Approach of The Body Shop Products

                    </h1><br>
                    <title>The Body Shop Case Study - Sustainable E-Commerce Solutions | Vidhema</title>



                    <!-- <p >We design and build superior digital products, delegating seamless user experiences across all modern platforms and devices and helping brands to expand their business globally. -->
                    <!-- </p><a  routerLink="/getaquote.html"
                                            class="ar_contect-industries-header"><span
                                                    >Request a Free
                                                    Quote</span></a> -->
                </div>
            </div>
        </div>
    </div>

</section>

<div class="casestudy-details pt-120 pb-120">
    <div class="container logo-box">
        <img src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/bodyshop%20logo.jpg?alt=media&token=b765e721-882a-4c9f-bd3a-168f3a640739"
            alt="image" class="ilast-logo">

    </div>
    <div class="container">
        <div class="row gy-5">
            <div class="col-lg-8">
                <div class="case-details-single">
                    <h2>The Body Shop
                    </h2>
                    <p>
                        The Body Shop is a cosmetic brand, known to sell cruelty-free products around the world. It is
                        the one-stop destination for all women looking for skincare, haircare, bath, and body products.
                        The Body Shop is in the business for the last 40 years and still smashing beauty spectrum
                        standards to their top level.

                    </p>
                    <img src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/two-caucasian-blonde-women-different-ages-are-tasting-cosmetic-product-while-sitting-white-background-skin-care-hydration-concept_197531-31442.webp?alt=media&token=92e56a0d-6fd4-4e42-99e4-b20f7ab5428a"
                        alt="image" class="img-fluid">
                </div>
            </div>
            <div class="col-lg-4">
                <div class="case-sidebar-area">
                    <ul class="case-info-list">
                        <li><span><img src="../../../assets/images/sidebar-arrow.svg" alt="image">Team Size :</span>
                            <h5>18 Members </h5>
                            <h5>
                                Magento Team | NodeJS Team | MongoDB Team | QA | BA | iOS Team | Android Team | UI/UX
                                Designers
                            </h5>
                        </li>
                        <li><span><img src="../../../assets/images/sidebar-arrow.svg" alt="image">Industry :</span>
                            <h5>Retail & Ecommerce, Beauty Products
                            </h5>
                        </li>
                        <li><span><img src="../../../assets/images/sidebar-arrow.svg" alt="image">Duration :</span>
                            <h5> 1 Year

                            </h5>
                        </li>
                    </ul>
                </div>
            </div>

        </div>
    </div>
    <div class="container">
        <div class="row">
            <div class="col-lg-12 case-details-single">


                <div class="area">
                    <h4> Who is the Client?</h4>
                    <p class="para">The Body Shop was started by the late British human rights and environmental
                        campaigner Dame Anita Roddick in the year 1976. At the start of their journey, they sold 25
                        beauty products that were produced using natural ingredients. And the products produced by The
                        Body Shop were ethically sourced and cruelty-free. The Body Shop has franchised outlets in more
                        than 60+ countries. And there are over 1500 beauty products sold in 2500+ stores owned by the
                        company.

                    </p>
                    <p class="para">
                        The Body Shop holds a considerable amount of market share, especially in the Asian market. The
                        Body Shop also has an influential presence in ecommerce stores worldwide, apart from their
                        physical stores. The beauty product brand maintains its digital commerce presence to let its
                        potential customers get the expected products delivered to their doorstep.
                    </p>
                </div>
                <div class="area">
                    <h4> Purpose of the Client
                    </h4>
                    <p class="para">The purpose of the client is to maintain the performance of the ecommerce website
                        and improve the shopping experience of all Indian customers. Another goal was to make sure that
                        they have the application to engage more customers and deliver their desired beauty products to
                        their doorstep. The website should also have to be mobile responsive and user-friendly for the
                        users browsing through mobile phones.
                    </p>


                </div>
            </div>
        </div>
    </div>
    <div class="full-area-bg">
        <div class="container">
            <div class="row">
                <div class="col-md-8">
                    <div class="case-details-single">
                        <div class="area">
                            <h4> Challenge
                            </h4>
                            <p class="para text-design">

                                The Body Shop was facing a humongous challenge with its website because of the poor
                                loading speed of the Home Page, Categories, Checkout Page, and Product Pages. The
                                features implemented in the website were not very much user-friendly and engaging. The
                                Body Shop came across Vidhema Technologies' expert team of developers to overcome their
                                issues.

                            </p>

                            <div class="list-title  list-space"><img class="img-value"
                                    src="../../../assets/images/list-arrow.svg" alt="image">
                                <p class="para">
                                    The website was developed in Magento 2.0 Community Edition.
                                </p>
                            </div>
                            <div class="list-title  list-space"><img class="img-value"
                                    src="../../../assets/images/list-arrow.svg" alt="image">
                                <p class="para">
                                    The client was facing an extension issue on their website.
                                </p>
                            </div>

                            <div class="list-title  list-space"><img class="img-value"
                                    src="../../../assets/images/list-arrow.svg" alt="image">
                                <p class="para">
                                    The Body Shop platform also required applications for its users.
                                </p>
                            </div>

                            <div class="list-title  list-space"><img class="img-value"
                                    src="../../../assets/images/list-arrow.svg" alt="image">
                                <p class="para">
                                    There were so many third-party APIs and plugins included in the process which needed
                                    to be migrated.
                                </p>
                            </div>

                            <div class="list-title  list-space"><img class="img-value"
                                    src="../../../assets/images/list-arrow.svg" alt="image">
                                <p class="para">
                                    Their website and physical store used to work differently.
                                </p>
                            </div>

                            <div class="list-title  list-space"><img class="img-value"
                                    src="../../../assets/images/list-arrow.svg" alt="image">
                                <p class="para">
                                    There was no separate categorical presentation of inventories and orders.
                                </p>
                            </div>

                            <div class="list-title  list-space"><img class="img-value"
                                    src="../../../assets/images/list-arrow.svg" alt="image">
                                <p class="para">
                                    The client wanted to have methodologies implemented according to the latest
                                    technologies and trends.
                                </p>
                            </div>


                        </div>

                    </div>
                </div>
                <div class="col-md-4">
                    <img src="../../../assets/images/girl.svg.svg" alt="Girl Building">
                </div>
            </div>
        </div>
    </div>
    <!-- <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="case-details-single">
                    <div class="area">
                        <h4> Website Features</h4>
                        <p class="para">The payment gateway of the website was created with three major gateways:</p>
                        <ul>
                            <li>GrabPay</li>
                            <li>PayPal</li>
                            <li>eNets</li>
                        </ul>
                        <P class="para">
                            Similarly, the Cynthia Rowley website has the Loyalty Club feature where the customers get
                            loyalty points after they make a purchase.
                        </P>
                        <p class="para">
                            The loyalty club feature includes various clubs to make points for your purchase. With these
                            ways, the customers can unlock some exciting perks for themselves.
                        </p>
                        <div class="solution-box">
                            <div class="col-12 para-text">


                                <div class="list-title  list-space"><img class="img-value"
                                        src="../../../assets/images/list-arrow.svg" alt="image">
                                    <p class="para">
                                        <b>Loyalty Club:</b> This feature will benefit the customer with exclusive
                                        rewards after entering the loyalty club.
                                    </p>
                                </div>
                                <div class="list-title  list-space"><img class="img-value"
                                        src="../../../assets/images/list-arrow.svg" alt="image">
                                    <p class="para">
                                        <b>Gratitude Points:</b> Customers can earn gratitude points for the actions
                                        they perform on the website. Later, those points will be converted into awesome
                                        rewards.

                                    </p>
                                </div>
                                <div class="list-title  list-space"><img class="img-value"
                                        src="../../../assets/images/list-arrow.svg" alt="image">
                                    <p class="para">

                                        <b>Referrals:</b> Customers can refer the website to their family or friends and
                                        claim their own reward when they make a purchase.

                                    </p>
                                </div>
                                <div class="list-title  list-space"><img class="img-value"
                                        src="../../../assets/images/list-arrow.svg" alt="image">
                                    <p class="para">

                                        <b>VIP:</b> This pass will give access to customers for exclusive rewards. For
                                        this, customers have to reach higher tiers to get more exclusive perks.

                                    </p>
                                </div>


                            </div>

                        </div>
                        <p class="para">
                            The other features implemented by our team of adroit developers were:
                        </p>
                        <ul>
                            <li>
                                Multi-Language: The website was built with various language options which are beneficial
                                for customers from around the globe.
                            </li>
                            <li>
                                Social Sharing: With the help of this feature, users and consumers can easily share
                                their favorite outfits on their social media platforms to promote the dress as well as
                                the website.
                            </li>
                            <li>
                                Gift Card: After making a purchase, users will receive a gift card as a reward for their
                                purchase.
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div> -->
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="case-details-single">
                    <div class="area">
                        <h4> Solution</h4>
                        <p class="para">The client connected with Vidhema Technologies for the implementation,
                            integration, and modification of their previous website with new and ongoing technologies.
                            Also, The Body Shop’s client wanted to have an application for their brand. When we got the
                            project it took us 2-3 months of requirement analysis and after that, we started the
                            development of the project.
                        </p>
                        <P class="para">
                            Initially, The Body Shop website was in Magento, and our team of adroit developers
                            re-developed it in the “Headless” form. We developed the backend in Magento 2 Enterprise
                            Edition with Node JS and MongoDB
                            and the frontend in React JS for Web and PWA and Native Apps for iOS and Android.

                        </P>

                        <P class="para">
                            We have integrated the third-party APIs into Magento and Node JS.
                        </P>

                        <P class="para">
                            The list of the third-party tools that we have integrated is as under:
                        </P>
                        <ul>
                            <li>
                                Shipping & Warehouse → Vinculum + Click up
                            </li>

                            <li>
                                Wallet → Qwikcilver
                            </li>

                            <li>
                                Payment Gateway → CC Avenue + Razor Pay
                            </li>

                            <Li>
                                Reward → Migrated into Easy Reward
                            </Li>

                            <li>
                                For Analytics → Clevertap (Implemented for the first time by our team of developers)
                            </li>

                            <li>
                                Reviews → Bazaarvoice (Implemented for the first time by our team of developers)

                            </li>

                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="container">
        <div class="row">
            <div class="col-lg-12 case-details-single">
                <div class="area">
                    <h4> Results</h4>
                    <p class="para">
                        For any business that wants to attain the required results and wants to accomplish online
                        marketing needs,
                        the ecommerce website must be high-performing with high stability. After partnering with the
                        Vidhema Technologies team, The Body Shop achieved many results for the betterment of their
                        journey towards achieving the desired goals.

                    </p>

                    <ul>
                        <li>
                            They have expanded thoroughly in India and gained many customers
                            after taking services from our proficient team of developers and designers.
                        </li>
                    </ul>

                    <ul>
                        <li>
                            During the festive season like Diwali, The Body Shop witnessed around 5.53 lakh of customers
                        </li>
                    </ul>

                    <ul>
                        <li>
                            The website and application became more engaging and user-friendly.
                        </li>
                    </ul>

                    <ul>
                        <li>
                            Inventories and Orders implementation has been done separately for the customers.
                        </li>
                    </ul>

                    <ul>
                        <li>
                            The Body Shop website showcases stability and high performance during peak times such as
                            festive times or sale times without compromising performance.
                            Eventually, resulted in increased sales and gaining more customers than before.
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <!-- <section class="quote-box" style="    background-color: #0d052a;">
        <div class="container">
            <div class="row">
                <div class="col-md-9">
                    <h4>Are You Ready To Discuss Your Project With Us?</h4>
                </div>
                <div class="col-md-3">
                    <button routerLink="/hire-shopify-developers.html">Hire Our Experts</button>
                </div>
            </div>
        </div>
    </section> -->
    <div class="container">
        <div class="row gy-5">
            <div class="col-lg-12">
                <div class="case-details-single">

                    <!-- <p>Also, the ill person can share their point of story on this platform where that person can publish it on their own or can make someone close a nominee and that person can publish it after sometime. </p>
                    <div class="list-title"><img src="../../../assets/images/list-arrow.svg" alt="image">
                        <p>
                         The main concern of the client was that the deployed product does not look like any other social media platform. Therefore, a very close look at the UI phase and the development phase was kept to achieve this difference in experience.
                        </p>
                             </div>
                             <div class="list-title"><img src="../../../assets/images/list-arrow.svg" alt="image">
                                <p>
                                    More than writing memorials and tributes, the app had features such as SOS alerts, notifying people in case of emergency, asset management, critical alerts, posting, and commenting which were a custom build.
                                </p>
                                     </div>
                           
                                     <div class="list-title"><img src="../../../assets/images/list-arrow.svg" alt="image">
                                        <p>
                                            The user experience and user interface needed to take care of from both ends making it user-friendly for the users as it was mostly used by old age people. 
                                        </p>
                                             </div> -->
                    <!-- <div class="container"> -->



                    <!-- </div> -->
                    <div class="area">
                        <h4>Technologies and Tools </h4>

                        <!-- <ul class="process-list half-description tech-des">
                            <li>
                                <div class="list-title  list-space"><img
                                        src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/shopifylogo.png?alt=media&token=7cc6d73f-ed1d-4373-9afa-42e7669ad864"
                                        alt="image" class="tech-logo">
                                    <h5>Angular</h5>
                                </div>
                            </li>
                        </ul>

                        <ul class="process-list half-description tech-des">
                            <li>
                                <div class="list-title  list-space"><img
                                        src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/shopifylogo.png?alt=media&token=7cc6d73f-ed1d-4373-9afa-42e7669ad864"
                                        alt="image" class="tech-logo">
                                    <h5>Angular</h5>
                                </div>
                            </li>
                        </ul> -->
                        <ul class="process-list half-description tech-des">
                            <li>
                                <div class="list-title  list-space"><img
                                        src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/magento-logo-7F3911AE9E-seeklogo.com.png?alt=media&token=98b9367a-23dd-42a8-a7c8-7d69bed9c05d"
                                        alt="image" class="tech-logo">
                                    <!-- <h5>Angular</h5> -->
                                </div>
                            </li>
                            <li>
                                <div class="list-title  list-space"><img src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/aws.png?alt=media&token=316590f4-daa3-48e4-ba31-6aaa67cd0962"
                                        alt="image" class="tech-logo">
                                    <!-- <h5>Ionic</h5> -->
                                </div>
                            </li>

                            <li>
                                <div class="list-title  list-space"><img src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/React%20native.png?alt=media&token=ea4f404f-bfa8-4a7d-9692-fcdf54811ab8"
                                        alt="image" class="tech-logo">
                                    <!-- <h5>MySQL</h5> -->
                                </div>
                            </li>

                            <li>
                                <div class="list-title  list-space"><img src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/node%20js.png?alt=media&token=c37cf052-b478-49a4-b1b1-f21102accaa8"
                                        alt="image" class="tech-logo">
                                    <!-- <h5>Node JS</h5> -->
                                </div>
                            </li>

                            <li>
                                <div class="list-title  list-space"><img src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/React%20js.png?alt=media&token=44b17a39-f74d-4339-8cda-3aee9705b6f9"
                                        alt="image" class="tech-logo">
                                    <!-- <h5>MongoDB  </h5> -->
                                </div>
                            </li>

                            <li>
                                <div class="list-title  list-space"><img src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/PWA.png?alt=media&token=529b4508-b215-403d-8083-a58ff98af412"
                                        alt="image" class="tech-logo">
                                    <!-- <h5>MongoDB  </h5> -->
                                </div>
                            </li>

                            <li>
                                <div class="list-title  list-space"><img src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/native%20apps.png?alt=media&token=f19d4c6e-bd35-418e-8555-50024069f337"
                                        alt="image" class="tech-logo">
                                    <!-- <h5>MongoDB  </h5> -->
                                </div>
                            </li>

                        </ul>


                    </div>



                    <div class="container">
                        <div class="row">



                            <div class="area">
                            </div>

                        </div>
                    </div>









                </div>
            </div>
        </div>
    </div>
</div>